import React, { useState, useEffect } from 'react'
import {
  Box,
  TextField,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

interface AspectSelectorProps {
  width: number
  height: number
  onChange: (width: number, height: number) => void
}

export function AspectSelector({ width, height, onChange }: AspectSelectorProps) {
  const [localWidth, setLocalWidth] = useState(width)
  const [localHeight, setLocalHeight] = useState(height)
  const [aspectPreset, setAspectPreset] = useState('')

  useEffect(() => {
    onChange(localWidth, localHeight)
  }, [localWidth, localHeight, onChange])

  const handlePresetChange = (preset: string) => {
    setAspectPreset(preset)
    switch (preset) {
      case '16:9':
        setLocalWidth(1920)
        setLocalHeight(1080)
        break
      case '3:2':
        setLocalWidth(1536)
        setLocalHeight(1024)
        break
      case '2:3':
        setLocalWidth(1024)
        setLocalHeight(1536)
        break
      case '9:21':
        setLocalWidth(1080)
        setLocalHeight(2520)
        break
      case 'ultrawide':
        setLocalWidth(2560)
        setLocalHeight(1080)
        break
      default:
        break
    }
  }

  return (
    <Accordion sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>Aspect</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <TextField
            label="Width"
            type="number"
            value={localWidth}
            onChange={(e) => setLocalWidth(Number(e.target.value))}
          />
          <TextField
            label="Height"
            type="number"
            value={localHeight}
            onChange={(e) => setLocalHeight(Number(e.target.value))}
          />
        </Box>

        <Accordion>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Select Preset Aspect</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <RadioGroup
              value={aspectPreset}
              onChange={(e) => handlePresetChange(e.target.value)}
            >
              <FormControlLabel value="16:9" control={<Radio />} label="Landscape 16:9" />
              <FormControlLabel value="3:2" control={<Radio />} label="Landscape 3:2" />
              <FormControlLabel value="2:3" control={<Radio />} label="Portrait 2:3" />
              <FormControlLabel value="9:21" control={<Radio />} label="Phone Background 9:21" />
              <FormControlLabel value="ultrawide" control={<Radio />} label="Ultrawide" />
            </RadioGroup>
          </AccordionDetails>
        </Accordion>
      </AccordionDetails>
    </Accordion>
  )
}
